<template>

  <mw-dialog  size="small_small" :footerButton="footerButton" ref="secDialog" :close-on-click-modal="false">

    <el-col :span="12">
       <mw-tree :url="deptTreeUrl" ref="tree"
              :async="true" :expandedFirst="true"
              :multiple="false"  @changed="changed"></mw-tree>
    </el-col>

     <el-col :span="12">

        <mw-table ref="dataTable"  :columns="columns" :defaultParamsAutoLoad="true"
                  :autoLoad="false" :pagination="false" :defaultParams="defaultParams"
                  :api="api" :singleSelect="true">
        </mw-table>
    </el-col>

 </mw-dialog>

</template>
<script >

    export default {
        props: {
          params: {
            type: Object
          }
        },
        data() {
            return {
              // deptTreeUrl: this.mwUrl('/api/org/listDepartmentListAble'),
              api: 'org.listUser',
              footerButton: [{
                label: '取消',
                func: this.cancel,
                type: 'default'
              },
              {
                label: '确定',
                func: this.save
              }],
              defaultParams: {},
              columns: [{type: 'selection'},{type: 'index'},
              {prop: 'name',label: '名称',tooltip: true}]
            }
        },
      computed: {
        deptTreeUrl() {
          // 不是开发账号过滤不显示的部门
          if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
          return this.mwUrl("/api/org/listDepartment")
        }
      },
      methods:{

        changed(data){
          this.refreshTableDefaultParams({ departmentId : data.id});

        },

        refreshTableDefaultParams(params) {
          this.defaultParams=params;
        },

        save(){
           this.$emit('chooseSec');
           this.mwRef('secDialog').hide();
        },

        cancel(){
          this.mwRef('secDialog').hide();
        },

        // 得到表格选中的数据
        getValue(){
          return this.mwRef('dataTable').getMultipleSelection();
        },

        show(){
          this.mwRef('secDialog').show();
        },
        refresh(){
          this.mwRef('tree').refresh();
        }

      }
    }
</script>





// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/chooseSecretary.vue